export const storageKeys = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  loginDetails: "loginDetails",
};

export const content = {
  0: [
    "Counting Objects",
    "Recognizing Numbers",
    "Shapes and Colors",
    "Sorting and Matching",
    "Comparing Sizes",
    "Simple Patterns",
  ],
  1: [
    "Addition Within 10",
    "Subtraction Within 10",
    "Place Value",
    "Counting to 100",
    "Measuring Length",
    "Telling Time to the Hour",
    "Basic Shapes and Geometry",
  ],
  2: [
    "Addition and Subtraction Within 100",
    "Skip Counting",
    "Introduction to Multiplication",
    "Measuring and Comparing Lengths",
    "Time and Calendars",
    "Money and Coins",
    "Data and Graphs",
  ],
  3: [
    "Multiplication and Division Facts",
    "Fractions of a Whole",
    "Place Value to Thousands",
    "Addition and Subtraction Within 1000",
    "Telling Time to the Minute",
    "Perimeter of Shapes",
    "Interpreting Data",
  ],
  4: [
    "Odd and Even Numbers",
    "Words For Numbers, Numbers For Words",
    "Number Sequence",
    "Recognizing Patterns",
    "Inverse Multiplication And Division",
    "Fractions, Measurements",
    "Percentage",
    "Comparing Fractions",
  ],
  5: [
    "Fractions, Decimal, Percentage",
    "Number Line",
    "Cost and Currency",
    "Probability",
    "Time Conversions",
    "Elements of Shapes",
    "Types of Transformations",
    "Comparing Decimal Numbers",
  ],
  6: [
    "Measuring Units",
    "Unit Conversions",
    "Geometry and Geometrical Angles",
    "Types of Triangles",
    "Area, Perimeter of Shapes",
    "Coordinate Geometry",
    "Fractions, Decimals, Percentage",
    "Integers on Number Line",
    "Ordinal And Nominal Data in Graphs",
    "Calculate Total Durations",
    "Counting in Designs",
  ],
  7: [
    "Fractions, Decimal, Percentage",
    "Number Line",
    "Cost and Currency",
    "Probability",
    "Time Conversions",
    "Elements of Shapes",
    "Types of Transformations",
    "Comparing Decimal Numbers",
  ],
  8: [
    "Index Laws",
    "Operations with rational and irrational numbers",
    "Terminating and repeating decimals",
    "Rates and Ratios",
    "Profit and Loss",
    "Algebraic Expressions and its operations",
    "Linear and Non-linear equations",
    "Perimeter, Area and Volume of Shapes",
    "Unit Conversion for Area and Volume",
    "Calculating using time zones",
    "Congruence of Plane Shapes",
    "Congruent Triangles",
    "Complementary Events, Sum of Probabilities",
    "Two-way tables and Venn Diagrams",
    "Sampling practicalities and implications",
    "Variation of means and proportions of ranges",
  ],
  9: [
    "Direct and Indirect Proportion",
    "Simplifying expressions using Index Laws",
    "Scientific Notation",
    "Simple Interest",
    "Set Structures",
    "Distance, Midpoint and Gradient of Linear Equations",
    "Linear and non-linear graphs with Coordinate",
    "Area of Composite Shapes",
    "Surface Area and volume of Cylinder",
    "Enlargement transformation",
    "Right prisms and Similar figures",
    "Pythagoras Theorem",
    "Trigonometric Ratios",
    "Two-step chance experiments",
    "Numerical and categorical variables",
  ],
};
